import {useOperationsContext} from '../../../../../context/OperationsContextProvider';
import {SVG} from '../../../../../constants/assetLists';
import BriefBox from './BriefBox';
import { useMemo } from 'react';

function Briefs() {
  const {briefData, expandDailyBriefSections, dailyBriefGroupBy, setExpandDailyBriefSections} =
    useOperationsContext();

  const handleExpandSection = (key: string) => {
    setExpandDailyBriefSections(prev => {
      if (prev.includes(key)) {
        return prev.filter(item => item != key);
      } else {
        return [...prev, key];
      }
    });
  };

  const totalReservations = useMemo(
    () =>
      dailyBriefGroupBy === "announcementType"
        ? briefData?.find(
            (g: any) => g.group?._id === "tableReservation",
          )?.announcements?.length || 0
        : briefData?.reduce(
            (sum: number, g: any) =>
              sum +
              (g.announcements?.filter(
                (a: any) => a.announcementType === "Reservation",
              ).length || 0),
            0,
          ),
    [briefData, dailyBriefGroupBy],
  );

  return (
    <div className="flex-1 min-h-0 py-3 px-4 flex flex-col gap-3">
      {briefData.length == 0 && (
        <div className="bg-pastelYellow rounded-lg p-2 ">
          <p className="text-lg font-semibold text-black m-0 text-center">
            לא נמצאו תוצאות לתצוגה
          </p>
        </div>
      )}

      {totalReservations > 0 && <div className="flex items-center gap-3 pb-2 border-b-2 border-b-white">
        <button className="w-[20px] h-[20px]" disabled>
          <img
            src={SVG.tableIcon}
            alt="table"
            className="w-full h-full object-contain"
          />
        </button>

        <p className="m-0 text-[18px] font-medium">הזמנת שולחן</p>

        <p className="m-0 text-[18px] font-medium">
          ({totalReservations || 0})
        </p>
      </div>}

      {briefData?.map((brief: any, index: number) => {
        if (brief?.group?._id === "tableReservation") return null;
        const group = brief?.group?.name;
        const isExpanded = expandDailyBriefSections.includes(group);

        return (
          <div
            key={index}
            className="w-full pb-2 border-b-2 border-b-white flex flex-col gap-2"
          >
            <div className="flex items-center gap-3">
              <button
                className="w-[12px] h-[12px]"
                onClick={() => handleExpandSection(group)}
              >
                <img
                  src={!isExpanded ? SVG.downBlueIcon : SVG.lessThanBlueIcon}
                  alt="add"
                  className="w-full h-full object-contain"
                />
              </button>

              <p className="m-0 text-[18px] font-medium text-deepAqua">
                {group}
              </p>

              <p className="m-0 text-[18px] font-medium text-deepAqua">
                ({brief?.announcements?.length || 0})
              </p>
            </div>

            {!isExpanded && (
              <div className="flex flex-col gap-1">
                {brief?.announcements?.map(
                  (announcement: any, index: number) => {
                    return (
                      <BriefBox
                        key={index}
                        announcement={announcement}
                        index={index}
                        groupId={brief?.group?._id}
                      />
                    );
                  },
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default Briefs;
